import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { bindActionCreators } from 'redux'
import * as licenseManagerActions from '../../../../redux/css-admin/licenseManager/actions'
import * as licenseManagerOperations from '../../../../redux/css-admin/licenseManager/operations'
import { Alert, Row, Button } from 'reactstrap'
import Loading from 'components/Loading/Loading'
import ErrorBoundary from '../../../../components/ErrorBoundary'
import SearchForm from './SearchForm'
import LicenseResultsGrid from './LicenseResultsGrid'
import SearchCriteriaBadges from 'components/SearchCriteriaBadges'

class LicenseSearch extends Component {
  static propTypes = {
    // map
    licenses: PropTypes.shape({
      set: PropTypes.func.isRequired,
      delete: PropTypes.func.isRequired,
    }),
  }

  constructor(props) {
    super(props)
    this.state = {
      criteria: {},
    }
  }

  search = () => {
    const { searchLicensesAndHandle } = this.props
    // set up criteria
    const { criteria } = this.state
    const formattedCriteria = this.getFormattedCriteria(criteria)
    searchLicensesAndHandle(formattedCriteria)
  }

  newSearch = () => {
    this.setState({ criteria: {} })
    this.props.clearLicenses()
  }

  removeProperty = (key, object) => {
    const { [key]: _, ...updatedObject } = object
    return updatedObject
  }

  addProperty = (key, value, object) => {
    return { ...object, [key]: value }
  }

  updateCriteria = (key, value, doSearch = false) => {
    const updatedCriteria = !value
      ? this.removeProperty(key, this.state.criteria)
      : this.addProperty(key, value, this.state.criteria)

    this.setState({ criteria: updatedCriteria || {} }, () => {
      if (Object.keys(this.state.criteria).length === 0) this.newSearch()
      if (doSearch) this.search()
    })
  }

  selectLicense = licenseId =>
    this.props.push(`${this.props.match.path}/${licenseId}`)

  getFormattedCriteria = criteria => {
    let selectedQueryKey = null

    // Only allow search by 1 query at a time, ordered by precedence (per requirements)
    // setupAdminEmail selection triggers a direct search, so it will never be included
    // in state
    if (!!criteria.nsLicenseId) {
      selectedQueryKey = 'nsLicenseId'
    } else if (!!criteria.licenseId) {
      selectedQueryKey = 'licenseId'
    } else if (!!criteria.nsSubscriptionId) {
      selectedQueryKey = 'nsSubscriptionId'
    } else if (!!criteria.subscriptionId) {
      selectedQueryKey = 'subscriptionId'
    }

    const formattedCriteria = {
      key: selectedQueryKey,
      value: criteria[selectedQueryKey],
    }

    return formattedCriteria
  }

  render = () => {
    const { criteria } = this.state
    const { isLoading, licenses, notFound } = this.props
    const showSearchResults = licenses.size > 0
    return (
      <React.Fragment>
        {showSearchResults && (
          <div className="float-right">
            <Button color="primary" onClick={this.newSearch} outline>
              <i className="fas fa-search" />
              &nbsp;New Search
            </Button>
            {/* additional buttons */}
          </div>
        )}
        <h2>License Search</h2>
        <hr />
        <ErrorBoundary>
          <Loading isLoading={isLoading} message="Searching..." />
          {!showSearchResults && (
            <SearchForm
              clearSearch={this.newSearch}
              criteria={criteria}
              search={this.search}
              updateCriteria={this.updateCriteria}
            />
          )}
          {showSearchResults && (
            <div>
              <React.Fragment>
                <SearchCriteriaBadges clearSearch={this.newSearch} managerType={"licenseManager"}/>
                <hr />
              </React.Fragment>
              <Row>
                <LicenseResultsGrid
                  licenses={[...licenses.values()]}
                  selectLicense={this.selectLicense}
                />
              </Row>
            </div>
          )}
          {notFound && <Alert color="warning mt-3">No results found</Alert>}
        </ErrorBoundary>
      </React.Fragment>
    )
  }
}

const mapStateToProps = ({ router, licenseManager }) => {
  return {
    ...router,
    ...licenseManager,
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...licenseManagerActions,
      ...licenseManagerOperations,
      push,
    },
    dispatch,
  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LicenseSearch)



// WEBPACK FOOTER //
// ./src/containers/css-admin/licenses/search/LicenseSearch.js